<template>
  <div class="back-to-top" v-show="showBackTop" @click="scrollToTop" :class="{ 'show': showBackTop }">
    <div class="back-to-top-content flex flex-x-c flex-y-c">
      <div class="arrow"></div>
      <div>返回顶部</div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      showBackTop: false,
      scrollTop: 0,
      scrollElement: null,
      isAppScrollContainer: false
    }
  },
  mounted() {
    // 获取#app元素作为滚动容器
    this.scrollElement = document.getElementById('app')

    // 判断#app元素是否是滚动容器（存在且有固定高度）
    this.isAppScrollContainer = this.scrollElement && this.scrollElement.clientHeight > 0

    // 绑定滚动事件监听
    if (this.isAppScrollContainer) {
      this.scrollElement.addEventListener('scroll', this.handleScroll)
    } else {
      window.addEventListener('scroll', this.handleScroll)
    }

    // 初始化时检查滚动位置
    this.handleScroll()
  },
  beforeDestroy() {
    // 清理事件监听器
    if (this.isAppScrollContainer && this.scrollElement) {
      this.scrollElement.removeEventListener('scroll', this.handleScroll)
    } else {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      // 获取当前滚动位置
      if (this.isAppScrollContainer && this.scrollElement) {
        this.scrollTop = this.scrollElement.scrollTop
      } else {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      }

      // 当滚动超过300px时显示返回顶部按钮
      this.showBackTop = this.scrollTop > 300
    },
    scrollToTop() {
      this.scrollElement.scrollTop = 0

    }
  }
}
</script>

<style scoped lang="less">
.back-to-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 100px;
  height: 40px;
  background-color: rgba(218, 222, 223, 0.8);
  // border-radius: 50%;
  cursor: pointer;

  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
  z-index: 1000;
  color: #333;

  &.show {
    opacity: 1;
    transform: translateY(0);
  }

  // &:hover {
  //   background-color: #00a1d6;
  //   transform: translateY(-3px);
  // }
  .back-to-top-content {
    height: 40px;
  }

  .arrow {
    width: 12px;
    height: 12px;
    border-top: 1px solid #333;
    border-left: 1px solid #333;
    transform: rotate(45deg);
    margin-right: 5px;
    margin-top: 5px;
  }
}
</style>